import axios from 'axios';

export default {
    getCalendarData(today) {
        return axios.get(`https://clients6.google.com/calendar/v3/calendars/bandyanas@gmail.com/events?calendarId=bandyanas%40gmail.com&singleEvents=true&timeZone=America%2FNew_York&maxAttendees=1&maxResults=250&sanitizeHtml=true&timeMin=${today}T00%3A00%3A00-04%3A00&key=AIzaSyBNlYH01_9Hc5S1J9vuFmu2nUqBZJNAXxs`);
    }
}